import { render } from "./ChallengesView.vue?vue&type=template&id=cf82d18c&scoped=true"
import script from "./ChallengesView.vue?vue&type=script&lang=js"
export * from "./ChallengesView.vue?vue&type=script&lang=js"

import "./ChallengesView.vue?vue&type=style&index=0&id=cf82d18c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf82d18c"]])

export default __exports__